/**
 * Wonderly Logo Marquee
 * Clones logo groups until the track fills the viewport, then scrolls by an
 * exact pixel loop distance (one group + inter-group gap) for a seamless loop.
 */
(function () {
  const ROOT_SELECTOR = '.wonderly-logo-marquee';
  const MAX_CLONES = 24;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function stripEditorAttributes(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.hasAttribute('data-shopify-editor-block')) {
      node.removeAttribute('data-shopify-editor-block');
    }

    node.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
      el.removeAttribute('data-shopify-editor-block');
    });
  }

  function getTrackGap(track) {
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap);
    return Number.isFinite(gap) ? gap : 0;
  }

  function resetTrack(track) {
    track.querySelectorAll('[data-marquee-clone]').forEach(function (clone) {
      clone.remove();
    });
    track.style.removeProperty('--wonderly-lm-loop-px');
    track.style.animation = 'none';
    track.dataset.marqueeReady = '';
  }

  function bindPauseOnHover(viewport, track) {
    if (!viewport || !track || viewport.dataset.pauseBound === 'true') return;
    if (!viewport.hasAttribute('data-pause-on-hover')) return;

    viewport.dataset.pauseBound = 'true';
    viewport.addEventListener('mouseenter', function () {
      track.style.animationPlayState = 'paused';
    });
    viewport.addEventListener('mouseleave', function () {
      track.style.animationPlayState = '';
    });
  }

  function initMarquee(root) {
    if (prefersReducedMotion()) return;

    const viewport = root.querySelector('.wonderly-logo-marquee__viewport');
    const track = root.querySelector('.wonderly-logo-marquee__track');
    const source = track && track.querySelector('.wonderly-logo-marquee__group[data-marquee-source]');

    if (!viewport || !track || !source) return;

    resetTrack(track);
    void track.offsetWidth;

    const gap = getTrackGap(track);
    const minTrackWidth = Math.max(viewport.clientWidth * 2, 1);
    let cloneCount = 0;

    while (track.scrollWidth < minTrackWidth && cloneCount < MAX_CLONES) {
      const clone = source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-marquee-clone', '');
      clone.removeAttribute('data-marquee-source');
      stripEditorAttributes(clone);
      track.appendChild(clone);
      cloneCount += 1;
    }

    if (cloneCount === 0) {
      const clone = source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-marquee-clone', '');
      clone.removeAttribute('data-marquee-source');
      stripEditorAttributes(clone);
      track.appendChild(clone);
    }

    const loopPx = source.offsetWidth + gap;
    if (loopPx > 0) {
      track.style.setProperty('--wonderly-lm-loop-px', loopPx + 'px');
    }

    track.style.animation = '';
    track.dataset.marqueeReady = 'true';

    bindPauseOnHover(viewport, track);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initMarquee);
  }

  let resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initAll(document);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('resize', onResize);
})();
